export default __webpack_public_path__ + "static/media/mikroskop.cd38ce88.jpg";